export const DEFAULT_LANGUAGE = 'us-en';

export const PRIVACY_URL = 'https://www.hp.com/%LANG%/privacy/privacy.html';
